/* House of Moh: — motion + commerce engine. No dependencies. */
(() => {
  'use strict';
  const d = document;
  const root = d.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const R = window.MOH || { routes: {}, strings: {} };

  /* ---------- Split words (for [data-split]) ---------- */
  const splitWords = (el) => {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/);
          const frag = d.createDocumentFragment();
          parts.forEach((p) => {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
            const w = d.createElement('span');
            w.className = 'm-w';
            const inner = d.createElement('span');
            inner.textContent = p;
            inner.style.setProperty('--i', i++);
            w.appendChild(inner);
            frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('m-w') && n.tagName !== 'BR') {
          walk(n);
        }
      });
    };
    walk(el);
  };

  /* ---------- Reveal observer ---------- */
  /* clip-path hidden elements are observed through their parent (proxy) */
  const proxies = new WeakMap();
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          (proxies.get(e.target) || []).forEach((t) => t.classList.add('is-in'));
          if (e.target.matches('[data-reveal]:not([data-reveal="mask"]),[data-split],[data-stagger],.m-marquee')) e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 })
    : null;
  const watch = (el) => {
    if (el.dataset.reveal === 'mask' && el.parentElement) {
      const p = el.parentElement;
      const list = proxies.get(p) || [];
      list.push(el);
      proxies.set(p, list);
      io.observe(p);
    } else io.observe(el);
  };

  const initReveal = (scope = d) => {
    $$('[data-split]', scope).forEach(splitWords);
    $$('[data-stagger]', scope).forEach((g) => Array.from(g.children).forEach((c, i) => c.style.setProperty('--i', i)));
    $$('[data-reveal="draw"]', scope).forEach((svg) => $$('path,circle,line,ellipse,polyline', svg).forEach((p) => p.setAttribute('pathLength', '1')));
    const els = $$('[data-reveal],[data-split],[data-stagger],.m-marquee', scope);
    if (!io || reduce) { els.forEach((e) => e.classList.add('is-in')); return; }
    els.forEach(watch);
  };

  /* ---------- Header: scrolled / hide on scroll down ---------- */
  const header = $('.m-header');
  if (header) {
    let last = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      const menuOpen = $('#m-menu')?.open;
      header.classList.toggle('is-hidden', !menuOpen && !header.classList.contains('is-pinned') && y > last && y > 240);
      last = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  }

  /* ---------- Dialogs (menu, drawer) ---------- */
  const openDialog = (dlg) => {
    if (!dlg || dlg.open) return;
    dlg.showModal();
    root.style.overflow = 'hidden';
  };
  const closeDialog = (dlg) => {
    if (!dlg || !dlg.open) return;
    dlg.close();
  };
  $$('dialog.m-menu, dialog.m-drawer').forEach((dlg) => {
    dlg.addEventListener('close', () => { root.style.overflow = ''; });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDialog(dlg); });
  });
  d.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const dlg = d.getElementById(opener.dataset.open);
      if (dlg) { e.preventDefault(); openDialog(dlg); }
    }
    const closer = e.target.closest('[data-close]');
    if (closer) closeDialog(closer.closest('dialog'));
  });

  /* ---------- Money ---------- */
  const fmt = (cents) => {
    const v = cents / 100;
    return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* ---------- Cart ---------- */
  const drawer = $('#m-cart');
  const sectionIds = () => {
    const ids = ['moh-cart-drawer'];
    const page = $('[data-cart-page]');
    if (page) ids.push(page.dataset.sectionId);
    return ids;
  };
  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'moh-cart-drawer') {
        const fresh = $('[data-drawer-inner]', doc);
        const cur = $('[data-drawer-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
      } else {
        const fresh = $('[data-cart-page]', doc);
        const cur = $(`[data-cart-page][data-section-id="${id}"]`);
        if (fresh && cur) cur.replaceWith(fresh);
      }
    });
    initReveal($('[data-drawer-inner]') || d);
  };
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.dataset.n = count; if (!el.classList.contains('is-added')) el.textContent = count;
      el.classList.toggle('has-items', count > 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };
  const flashAdded = () => {
    const hd = $('.m-header');
    if (hd) { hd.classList.remove('is-hidden'); hd.classList.add('is-pinned'); clearTimeout(hd._pin); hd._pin = setTimeout(() => hd.classList.remove('is-pinned'), 3200); }
    $$('[data-cart-count]').forEach((el) => {
      el.classList.add('is-added'); el.textContent = '✓ Added';
      clearTimeout(el._f);
      el._f = setTimeout(() => { el.classList.remove('is-added'); el.textContent = el.dataset.n || el.textContent; }, 3000);
    });
  };
  const post = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.description || json.message || 'Something went wrong');
    return json;
  };
  const refreshCart = async () => {
    const cart = await fetch(R.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    updateCount(cart.item_count);
    return cart;
  };
  const toast = (msg) => {
    let t = $('.m-toast');
    if (!t) {
      t = d.createElement('div');
      t.className = 'm-toast';
      t.setAttribute('role', 'status');
      Object.assign(t.style, { position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)', zIndex: 60, background: 'var(--aubergine)', color: 'var(--ivory)', padding: '12px 18px', borderRadius: '999px', fontSize: '13px', boxShadow: 'var(--shadow)', transition: 'opacity .4s', maxWidth: 'calc(100% - 32px)' });
      d.body.appendChild(t);
    }
    t.textContent = msg; t.style.opacity = '1';
    clearTimeout(t._h); t._h = setTimeout(() => { t.style.opacity = '0'; }, 3200);
  };

  const addItems = async (items, btn) => {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    try {
      const json = await post(R.routes.cart_add + '.js', { items, sections: sectionIds().join(','), sections_url: window.location.pathname });
      renderSections(json.sections);
      await refreshCart();
      flashAdded();
      if (btn) {
        btn.classList.add('is-added');
        const label = btn.querySelector('.m-btn__label, [data-label]');
        const old = label ? label.textContent : null;
        if (label) label.textContent = R.strings.added || 'Added';
        setTimeout(() => { btn.classList.remove('is-added'); if (label && old) label.textContent = old; }, 2200);
      }
      if (drawer) openDialog(drawer);
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
    }
  };

  R.addItems = addItems;

  d.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Math.max(1, Number(fd.get('quantity') || 1));
    if (!id) return;
    addItems([{ id, quantity }], form.querySelector('[type="submit"]'));
  });

  d.addEventListener('click', (e) => {
    const both = e.target.closest('[data-add-many]');
    if (both) {
      e.preventDefault();
      const ids = both.dataset.addMany.split(',').map(Number).filter(Boolean);
      addItems(ids.map((id) => ({ id, quantity: 1 })), both);
      return;
    }
    const qbtn = e.target.closest('[data-qty]');
    if (qbtn) {
      e.preventDefault();
      const line = qbtn.closest('[data-line]');
      if (!line) return;
      const key = line.dataset.key;
      const cur = Number(line.dataset.quantity);
      const next = qbtn.dataset.qty === 'remove' ? 0 : Math.max(0, cur + Number(qbtn.dataset.qty));
      changeLine(key, next, line);
      return;
    }
    const pdq = e.target.closest('[data-step]');
    if (pdq) {
      const input = pdq.parentElement.querySelector('input');
      if (input) input.value = Math.max(1, Math.min(Number(input.max) || 99, Number(input.value || 1) + Number(pdq.dataset.step)));
    }
  });

  const changeLine = async (key, quantity, line) => {
    const box = line.closest('[data-drawer-inner],[data-cart-page]');
    if (box) box.classList.add('is-busy');
    try {
      const json = await post(R.routes.cart_change + '.js', { id: key, quantity, sections: sectionIds().join(','), sections_url: window.location.pathname });
      renderSections(json.sections);
      updateCount(json.item_count);
    } catch (err) {
      toast(err.message);
      if (box) box.classList.remove('is-busy');
    }
  };

  d.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-attr]');
    if (note) post(R.routes.cart_update + '.js', { attributes: { [note.name]: note.type === 'checkbox' ? (note.checked ? 'Yes' : 'No') : note.value } }).catch(() => {});
  });

  $$('[data-rail]').forEach((rail) => {
    const bar = rail.parentElement.querySelector('.m-progress span');
    if (!bar) return;
    const upd = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const w = Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100);
      bar.style.setProperty('--w', w + '%');
      bar.style.setProperty('--x', max > 0 ? (rail.scrollLeft / max) * ((100 - w) / w) * 100 : 0);
    };
    rail.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  });

  /* ---------- Pointer niceties (desktop only) ---------- */
  if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-tilt]').forEach((el) => {
      let raf;
      el.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = el.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5;
          const y = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform = `perspective(900px) rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 6).toFixed(2)}deg) translateY(-4px)`;
        });
      });
      el.addEventListener('pointerleave', () => { cancelAnimationFrame(raf); el.style.transform = ''; });
    });
  }

  /* ================= ROUND 2: ultra layer ================= */
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* page curtain (first view per session only) */
  try {
    if (!reduce && !sessionStorage.getItem('moh-seen')) {
      sessionStorage.setItem('moh-seen', '1');
      const c = d.createElement('div');
      c.className = 'm-curtain'; c.setAttribute('aria-hidden', 'true');
      c.innerHTML = '<span class="m-logo" style="--logo-w:150px;color:#f6f2ec;animation:m-pulse 1s ease-in-out infinite alternate"></span>';
      d.body.appendChild(c);
      requestAnimationFrame(() => setTimeout(() => { c.classList.add('is-out'); setTimeout(() => c.remove(), 1200); }, 450));
    }
  } catch (e) {}

  /* hero collage: reveal, pointer + scroll parallax */
  $$('[data-collage]').forEach((col) => {
    if (io) io.observe(col); else col.classList.add('is-in');
    if (reduce) return;
    const hero = col.closest('.m-hero');
    if (fine) hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      col.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
      col.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
    });
    let t = false;
    window.addEventListener('scroll', () => { if (t) return; t = true; requestAnimationFrame(() => { col.style.setProperty('--sy', Math.min(1.2, window.scrollY / 700).toFixed(3)); t = false; }); }, { passive: true });
  });
  /* the collage uses the generic observer: mark in-view */
  if (io) $$('[data-collage]').forEach((c) => { proxies.set(c, [c]); });

  /* cursor ring */
  if (fine && !reduce) {
    const ring = d.createElement('div'); ring.className = 'm-cursor'; ring.setAttribute('aria-hidden', 'true'); d.body.appendChild(ring);
    let x = 0, y = 0, tx = 0, ty = 0, on = false;
    d.addEventListener('pointermove', (e) => { tx = e.clientX; ty = e.clientY; if (!on) { on = true; x = tx; y = ty; ring.classList.add('is-on'); } });
    d.addEventListener('pointerleave', () => { on = false; ring.classList.remove('is-on'); });
    const loop = () => { x += (tx - x) * 0.2; y += (ty - y) * 0.2; ring.style.transform = `translate3d(${x}px, ${y}px, 0)`; requestAnimationFrame(loop); };
    loop();
    d.addEventListener('pointerover', (e) => ring.classList.toggle('is-big', !!e.target.closest('a, button, .m-card, .m-phase, .m-feature, [data-tilt]')));
  }

  /* ===== 2D flower bloom on hover / tap ===== */
  if (!reduce) {
    const HOT = '.m-display, .m-h1, .m-h2, .m-h3, .m-scrub, .m-quote, .m-link, .m-navlink, .m-btn, .m-card__title, .m-phase__name, .m-feature__title, .m-pull, .m-sign, .m-eyebrow';
    const cols = [['#d9b8a8', '#c29a5b'], ['#e8c9c4', '#9b5f64'], ['#f3e1c3', '#c29a5b'], ['#dcd2e6', '#6d4a6b'], ['#cfe0d4', '#2f4a3e']];
    const NS = 'http://www.w3.org/2000/svg';
    const layer = d.createElement('div');
    layer.className = 'm-blooms'; layer.setAttribute('aria-hidden', 'true');
    d.body.appendChild(layer);
    let last = 0, live = 0;
    const flower = (x, y, burst) => {
      if (live > 28) return;
      const c = cols[(Math.random() * cols.length) | 0];
      const n = 5 + ((Math.random() * 3) | 0);
      const size = 20 + Math.random() * 22;
      const s = d.createElementNS(NS, 'svg');
      s.setAttribute('viewBox', '-20 -20 40 40'); s.setAttribute('width', size); s.setAttribute('height', size);
      s.setAttribute('class', 'm-bloom');
      let g = '';
      for (let i = 0; i < n; i++) g += '<ellipse cx="0" cy="-9" rx="4.6" ry="9.5" fill="' + c[0] + '" fill-opacity=".82" stroke="' + c[1] + '" stroke-width=".6" transform="rotate(' + (360 / n) * i + ')"/>';
      g += '<circle r="3.6" fill="' + c[1] + '"/><circle r="1.3" fill="#fbf9f5"/>';
      s.innerHTML = g;
      const dx = (Math.random() - 0.5) * (burst ? 90 : 36), dy = -14 - Math.random() * (burst ? 70 : 34), rot = (Math.random() - 0.5) * 220;
      s.style.cssText = 'left:' + (x - size / 2) + 'px;top:' + (y - size / 2) + 'px;--dx:' + dx + 'px;--dy:' + dy + 'px;--r:' + rot + 'deg';
      layer.appendChild(s); live++;
      setTimeout(() => { s.remove(); live--; }, 1500);
    };
    if (fine) d.addEventListener('pointermove', (e) => {
      if (!(e.target.closest && e.target.closest(HOT))) return;
      const now = performance.now();
      if (now - last < 110) return;
      last = now; flower(e.clientX, e.clientY, false);
    }, { passive: true });
    d.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      if (!(e.target.closest && e.target.closest(HOT))) return;
      for (let i = 0; i < 6; i++) setTimeout(() => flower(e.clientX, e.clientY, true), i * 60);
    }, { passive: true });
  }


  initReveal();
  root.classList.add('is-ready');
})();
